import { useContext } from 'preact/hooks'
import { getStylesFn } from 'core/helpers/styles'
import { ElementHostsOptions } from 'core/types/element/element_hosts'
import optionsPropTypes from 'PropsSpec'
import WidgetContext from '../Context'
import Host from './hosts/Host'

const extractStyles = getStylesFn(['paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'backgroundColor'], {
  display: 'flex',
  width: '100%',
  justifyContent: 'center'
})

type Props = {
  options: ElementHostsOptions
}

const Hosts = (props: Props) => {
  const { options } = props
  const { version } = useContext(WidgetContext)
  const { hosts } = version

  const styles = extractStyles(options)

  return (
    <div style={styles} className="wf_reset wf_hosts">
      {hosts.map((host, index) => (
        <Host
          key={index}
          avatarUrl={host.avatar_url}
          firstName={host.first_name}
          lastName={host.last_name}
          options={options}
        />
      ))}
    </div>
  )
}

Hosts.propTypes = {
  options: optionsPropTypes('hosts')
}

export default Hosts
